<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Amministrazione Trasparente', route: '/backoffice/amministrazione-trasparente/' }, { label: 'Aggiungi File', route: '/backoffice/amministrazione-trasparente/add' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Aggiungi file</h1>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formAmministrazioneTrasparente" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <h2>Dati file</h2>
            <span class="ac-meta">categoria, titolo e documento pdf</span>
        </div>

        <div class="fld">
            <label>* Categoria</label>
            <p-dropdown [options]="categorie" optionLabel="categoria" placeholder="Seleziona una categoria" formControlName="categoria" styleClass="w-full"></p-dropdown>
            <small class="text-red-600 block mt-2 font-medium" *ngIf="formAmministrazioneTrasparente.get('categoria')?.hasError('required') && (formAmministrazioneTrasparente.get('categoria')?.dirty || formAmministrazioneTrasparente.get('categoria')?.touched)">La categoria è obbligatoria.</small>
        </div>

        <div class="fld">
            <label>* Titolo</label>
            <input type="text" pInputText class="w-full" placeholder="Titolo" formControlName="titolo" name="titolo" id="titolo" required />
            <small class="text-red-600 block mt-2 font-medium" *ngIf="formAmministrazioneTrasparente.get('titolo')?.hasError('required') && (formAmministrazioneTrasparente.get('titolo')?.dirty || formAmministrazioneTrasparente.get('titolo')?.touched)">Il titolo è obbligatorio.</small>
        </div>

        <div class="fld">
            <app-file-upload [form]="formAmministrazioneTrasparente" [control]="'pdf'" [label]="'* File pdf'" [multiple]="false" [accept]="'application/pdf'" [text]="'Seleziona un file'" (load)="onPDFUpload($event)"></app-file-upload>
        </div>

        <div class="acc-actions">
            <a class="acc-btn acc-btn-ghost" routerLink="/backoffice/amministrazione-trasparente">Annulla</a>
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formAmministrazioneTrasparente.valid">Aggiungi file</button>
        </div>
    </form>
</section>
